/* Velvety reveal-on-scroll observer.
 *
 * Adds .is-revealed to any element carrying [data-velvety-reveal]
 * the first time it enters the viewport. Pairs with the CSS in
 * velvety-hover-effects.css. One-shot: we unobserve after the first
 * intersection so the animation doesn't replay on re-scroll.
 *
 * Falls back to immediately revealing everything when the user has
 * prefers-reduced-motion set or when IntersectionObserver is missing
 * (very old browsers).
 */
(function () {
  var targets = document.querySelectorAll('[data-velvety-reveal]');
  if (!targets.length) return;

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
    targets.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  targets.forEach(function (el) { io.observe(el); });
})();
